<template>
    <div>
        <table-title>筛选栏</table-title>
        <Form ref="queryFormRef" :model="queryParams" inline :label-width="110" :rules="rules">
            <FormItem label="参与人" prop="fromMemberId">
                <member-select roleId="LEASEE" v-model="queryParams.fromMemberId"></member-select>
            </FormItem>
            <FormItem label="下游列表">
                <Select v-model="queryParams.toMemberId" clearable filterable style="width:200px">
                    <Option v-for="item in memberList" :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
            </FormItem>
            <FormItem label="超期起始日">
                <DatePicker type="daterange" split-panels placeholder="请选择" :editable="false" @on-change="onCreateTime" style="width:200px"></DatePicker>
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="search">查询</Button>
        </Form>
        <table-title>下游合约明细查询</table-title>
        <datagrid ref="lg" :columns="cols" :queryParams="queryParams" paramsName="param" :autoLoad="false" :queryUrl="queryUrl" subListName>
            <template #default="{columns, data}">
                <Table :columns="columns" :data="data" border stripe size="small"></Table>
            </template>
        </datagrid>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            memberList: [],
            queryUrl: "http://CORE-CONTRACT/messageService/billService/queryContractDetailForHL",
            queryParams: {
                fromMemberId: "",
                toMemberId: "",
                expiredBeginDateBegin: "",
                expiredBeginDateEnd: "",
            },
            rules: {
                fromMemberId: [{ required: true, message: '请选择' }]
            },
            cols: [
                { title: "合约编号", key: "contractId" },
                { title: "停租编号 / 在租状态", key: "stopBillingRecordId" },
                { title: "租借人", key: "leaseeId", dict: ['bizObjects', 'member', true] },
                { title: "产品名称", key: "targetType", dict: ['target', 'type', true] },
                { title: "合约起租日期", key: "billingDate", formatter: "date" },
                { title: "合约停租日期", key: "stopBillingDate", formatter: "date" },
                { title: "超期起始日期", key: "expiredBeginDate", formatter: "date" },
                { title: "超期截止日期", key: "expiredEndDate", formatter: "date" },
                { title: "停租数量 / 在租数量", key: "amount" },
                { title: "超期天数", key: "expiredDays" }]
        }
    },
    watch: {
        'queryParams.fromMemberId': function (newVal) {
            if (newVal)
                this.getMember(newVal);

        }
    },
    methods: {
        onCreateTime(date) {
            this.queryParams.expiredBeginDateBegin = date[0];
            this.queryParams.expiredBeginDateEnd = date[1];
        },
        getMember(fromMemberId) {
            let data = {
                url: "http://MID-OPERATE-LEASE/messageService/hlService/queryToMemberIds",
                body: { fromMemberId }
            }
            this.invoke(data).then(res => {
                let params = {
                    url: "http://CORE-COMMON/messageService/dictService/queryEntries",
                    body: {
                        codes: res,
                        namespace: "bizObjects",
                        type: "member"
                    }
                }
                this.invoke(params).then(rs => {
                    this.memberList = rs;
                })
            })
        },
        async search() {
            let vaild = await this.$refs['queryFormRef'].validate();
            if (!vaild) return;
            this.$refs['lg'].loadFirstPage();
        }
    }

}
</script>

<style>
</style>